import { getRequest, postRequest, putRequest, deleteRequest } from '../services/http';

export const getLastInventory = async (data) => {
  try {
    if (data.page) {
      const response = await getRequest({
        url: `user/branch-stores/${data.id}/store-branch-products/?page=${data.page}`,
        token: data.token,
      });
      return response;
    } else {
      const response = await getRequest({
        url: `user/branch-stores/${data.id}/store-branch-products/`,
        token: data.token,
      });

      return response;
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getSearchProductInventory = async (data) => {
  try {
    if (data.page) {
      const response = await getRequest({
        url: `user/branch-stores/${data.id}/store-branch-products/?page=${data.page}&product__name=${data.searchWord}`,
        token: data.token,
      });
      return response;
    } else {
      const response = await getRequest({
        url: `user/branch-stores/${data.id}/store-branch-products/?product__name=${data.searchWord}`,
        token: data.token,
      });

      return response;
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getSearchSkuInventory = async (data) => {
  try {
    if (data.page) {
      const response = await getRequest({
        url: `user/branch-stores/${data.id}/store-branch-products/?page=${data.page}&product__sku=${data.searchSku}`,
        token: data.token,
      });
      return response;
    } else {
      const response = await getRequest({
        url: `user/branch-stores/${data.id}/store-branch-products/?product__sku=${data.searchSku}`,
        token: data.token,
      });

      return response;
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getSearchCategoryInventory = async (data) => {
  try {
    if (data.page) {
      const response = await getRequest({
        url: `user/branch-stores/${data.id}/store-branch-products/?page=${data.page}&product__category=${data.searchCategoryId}`,
        token: data.token,
      });
      return response;
    } else {
      const response = await getRequest({
        url: `user/branch-stores/${data.id}/store-branch-products/?product__category=${data.searchCategoryId}`,
        token: data.token,
      });

      return response;
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const updateLastStoreInventory = async (data) => {
  try {
    const response = await postRequest({
      url: `user/branch-stores/${data.id}/download-inventory/`,
      data: data.params,
      token: data.token,
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const downloadStoreInventory = async (data) => {
  try {
    const response = await getRequest({
      url: `user/branch-stores/${data.id}/download-inventory/`,
      data: data.params,
      token: data.token,
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const updateLastBaseInventory = async (data) => {
  try {
    const response = await postRequest({
      url: `user/branch-stores/${data.id}/download-base-inventory/`,
      data: data.params,
      token: data.token,
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const downloadBaseInventory = async (data) => {
  try {
    const response = await getRequest({
      url: `user/branch-stores/${data.id}/download-base-inventory/`,
      data: data.params,
      token: data.token,
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const updateProductInventory = async (data) => {
  try {
    const response = await putRequest({
      url: `user/branch-stores/${data.id}/store-branch-products/${data.productId}/`,
      data: data.params,
      token: data.token,
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const createProductInventory = async (data) => {
  try {
    const response = await postRequest({
      url: `user/branch-stores/${data.id}/store-branch-products/`,
      data: data.params,
      token: data.token,
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProductInventory = async (data) => {
  try {
    const response = await deleteRequest({
      url: `user/branch-stores/${data.id}/store-branch-products/${data.productId}/`,
      token: data.token,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBaseProducts = async (token, searchWord = '') => {
  try {
    const response = await getRequest({
      url: searchWord ? `products/?search=${searchWord}` : `products/`,
      token: token,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadProductsCsv = async ({ id, token, file }) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/branch-stores/${id}/update-products-from-csv/`,
      {
        method: 'POST',
        headers: {
          Authorization: `Token ${token}`,
        },
        body: formData,
      },
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Upload error:', errorData);
      throw new Error(errorData.error || 'Error uploading file');
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error('UploadProductsCsv error:', error);
    throw error;
  }
};

export const checkProductsCsvStatus = async ({ id, token }) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/user/branch-stores/${id}/check-csv-upload-status/`,
    {
      method: 'GET',
      headers: {
        Authorization: `Token ${token}`,
      },
    },
  );
  if (!response.ok) throw new Error('Error checking status');
  return response.json();
};

export const getProductImages = async (data) => {
  try {
    const response = await getRequest({
      url: `user/branch-stores/${data.storeId}/store-branch-products/${data.productId}/images/`,
      token: data.token,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadProductImage = async (data) => {
  try {
    const formData = new FormData();
    formData.append('image', data.file);
    if (data.description) formData.append('description', data.description);

    const response = await postRequest({
      url: `user/branch-stores/${data.storeId}/store-branch-products/${data.productId}/images/`,
      data: formData,
      token: data.token,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProductImage = async (data) => {
  try {
    const response = await deleteRequest({
      url: `user/branch-stores/${data.storeId}/store-branch-products/${data.productId}/images/${data.imageId}/`,
      token: data.token,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getProductDetail = async (data) => {
  try {
    const response = await getRequest({
      url: `user/branch-stores/${data.storeId}/store-branch-products/${data.productId}/`,
      token: data.token,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
